import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-background text-center text-foreground" aria-label="Limited time offer" data-id="element-217" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-accent" aria-hidden="true" data-id="element-218" data-mp="36bimxjk5vlee" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-219" data-mp="31iz9qnpdysa4">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-accent" data-id="element-220" data-mp="31h4rjh5i1e9q">
          <AlertTriangleIcon className="h-4 w-4 text-fire" aria-hidden="true" data-id="element-221" data-mp="3b910jn94iosq" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-222" data-mp="3p8jy5m4b6hqs" />
        <p className="mt-7 font-bold text-muted" data-id="element-223" data-mp="3p7ilxebk3p7h">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-accent" aria-hidden="true" data-id="element-224" data-mp="3l7zwq6cpcryu" />
    </section>;
}